import dedent from 'dedent';

export const GET_NONCE_QUERY = dedent`
  query getNonce($address: String!) {
    auth {
      nonce(address: $address)
    }
  }
`;

export const AUTHENTICATE_QUERY = dedent`
  query authenticate($address: UserId!, $signature: HexString!, $message: String!, $magicAuth: MagicAuth) {
    auth {
      authenticate(address: $address, signature: $signature, message: $message, magicAuth: $magicAuth) {
        token
      }
    }
  }
`;
